<template>
  <v-menu bottom right>
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on" small>
        <v-icon small>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="grey lighten-5 subtitle-1">{{ title }}</v-card-title>
      <v-list>
        <v-list-item @click="onDetails" v-if="details">
          <v-list-item-icon>
            <v-icon small color="cyan">mdi-file-find</v-icon>
          </v-list-item-icon>
          <v-list-item-content>Details</v-list-item-content>
        </v-list-item>
        <v-list-item @click="onEdit" v-if="!hideEdit">
          <v-list-item-icon>
            <v-icon color="teal" small>mdi-pencil</v-icon>
          </v-list-item-icon>
          <v-list-item-content>Edit</v-list-item-content>
        </v-list-item>
        <confirmation-dialog @onConfirm="onRemove" v-if="!hideRemove">
          <v-list-item @click="">
            <v-list-item-icon>
              <v-icon small color="pink">mdi-delete</v-icon>
            </v-list-item-icon>
            <v-list-item-content>Delete</v-list-item-content>
          </v-list-item>
          <template slot="message">This will remove {{ itemLabel }}</template>
        </confirmation-dialog>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import ConfirmationDialog from "./ConfirmationDialog";
export default {
  name: "list-menu-actions",

  props: {
    item: { type: Object, default: () => ({}) },
    titleLabeler: { type: Function },
    details: { type: Boolean, default: () => false },
    hideRemove: { type: Boolean, default: () => false },
    hideEdit: { type: Boolean, default: () => false },
  },

  components: { ConfirmationDialog },

  computed: {
    itemLabel() {
      return this.item && this.item.node
        ? `${this.item.node.__typename}`
        : this.itemName || "Item";
    },
    title() {
      return this.titleLabeler ? this.titleLabeler(this.item) : "Label";
    },
  },

  methods: {
    onEdit() {
      this.$emit("edit", this.item);
    },
    onDetails() {
      this.$emit("details", this.item);
    },
    onRemove() {
      this.$emit("delete", this.item);
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/ListMenuActions.vue